// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"679":"333393af","787":"44d7b4f0"}[chunkId] + ".chunk.js";
};